(function () {
  document.addEventListener('click', function (event) {
    if (!event.target || typeof event.target.closest !== 'function') return;

    var reviewControl = event.target.closest('[data-spotmate-review-anchor]');
    if (reviewControl) {
      if (!window.SpotmateTracking || typeof window.SpotmateTracking.push !== 'function') return;

      var reviewLocation = reviewControl.getAttribute('data-spotmate-location') || 'pdp_rating_summary';
      var reviewProductId = reviewControl.getAttribute('data-product-id') || 'unknown';
      window.SpotmateTracking.push(
        'review_click',
        {
          review_location: reviewLocation,
          product_id: reviewProductId
        },
        {
          dedupeKey: [reviewLocation, reviewProductId].join(':'),
          dedupeWindowMs: 2000
        }
      );
      return;
    }

    var couponControl = event.target.closest('[data-spotmate-event="coupon_click"]');
    if (couponControl && !couponControl.disabled) {
      if (!window.SpotmateTracking || typeof window.SpotmateTracking.push !== 'function') return;

      var couponAction = couponControl.getAttribute('data-spotmate-action') || 'copy';
      var couponLocation = couponControl.getAttribute('data-spotmate-location') || 'unknown';
      var couponSectionId = couponControl.getAttribute('data-spotmate-section') || 'unknown';
      var couponBlockId = couponControl.getAttribute('data-spotmate-block') || 'unknown';
      window.SpotmateTracking.push(
        'coupon_click',
        {
          coupon_action: couponAction,
          coupon_location: couponLocation,
          section_id: couponSectionId,
          block_id: couponBlockId
        },
        {
          dedupeKey: [couponAction, couponLocation, couponSectionId, couponBlockId].join(':'),
          dedupeWindowMs: 1500
        }
      );
      return;
    }

    var control = event.target.closest('[data-spotmate-event="faq_expand"]');
    if (control) {
      window.queueMicrotask(function () {
        if (control.getAttribute('aria-expanded') !== 'true') return;
        if (!window.SpotmateTracking || typeof window.SpotmateTracking.push !== 'function') return;

        var sectionId = control.getAttribute('data-spotmate-section') || 'unknown';
        var blockId = control.getAttribute('data-spotmate-block') || 'unknown';
        window.SpotmateTracking.push(
          'faq_expand',
          {
            section_id: sectionId,
            faq_id: blockId
          },
          {
            dedupeKey: [sectionId, blockId].join(':'),
            dedupeWindowMs: 2000
          }
        );
      });
      return;
    }

    var stickyControl = event.target.closest('[data-spotmate-event="sticky_atc_click"]');
    if (!stickyControl || stickyControl.disabled) return;
    if (!window.SpotmateTracking || typeof window.SpotmateTracking.push !== 'function') return;

    var productForm = stickyControl.closest('form');
    var variantInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    var stickySectionId = stickyControl.getAttribute('data-spotmate-section') || 'unknown';
    var productId = stickyControl.getAttribute('data-spotmate-product') || 'unknown';
    var variantId = variantInput ? variantInput.value : 'unknown';
    window.SpotmateTracking.push(
      'sticky_atc_click',
      {
        section_id: stickySectionId,
        product_id: productId,
        variant_id: variantId
      },
      {
        dedupeKey: [stickySectionId, productId, variantId].join(':'),
        dedupeWindowMs: 2000
      }
    );
  });
})();
